/**
 * creates iframe to display blob in
 * @returns {void} void
 * @memberof OrderService
 */
export default ({ blob }) => {
  let csvIframe = window.document.createElement(`iframe`);
  // this is fix for IOS that removes "blob" from url when blob is open. By default when opening "blob" ios shows "blob" in url and this was flagged as an issue in CX-3515. It should display domain name at the top or other meningfull title and blob apparently might be confusing.
  // Now this is default browser behaviour and "blob" is actually part of the url itself so modifying this in url itself is out of question. The only way I found to remove it is to create iFrame and in there load the blob document into. Now then IOS seems to have an issue with back button as when browser back button is clicked safari never loads previous page. I found out that adding empty iframe, then removing and adding actual iframe where csv is loaded is the only way to get it working. User never exeprience this switch and it works as expected
  window.document.body.appendChild(csvIframe);
  csvIframe.remove();

  // now actual iframe
  csvIframe = window.document.createElement(`iframe`);
  csvIframe.id = `csvIframe`;
  csvIframe.style = `border: 0;overflow: auto;position: absolute; width: 100vw; height: 100vh; top: 0; left: 0; z-index: 999999999;background-color: #fff;`;
  window.document.body.appendChild(csvIframe);

  let clickable = window.document.createElement(`a`);
  clickable = window.document.createElement(`a`);
  clickable.href = window.URL.createObjectURL(blob);
  document.getElementById(`csvIframe`).contentDocument.children[0].children[1].appendChild(clickable);
  clickable.click();
  clickable.remove();

  /**
   * Removes inserted frame and listener to avoid mem. leaks
   * @returns {void} void
   * @memberof OrderService
   */
  const removeIframe = () => {
    csvIframe.remove();
    window.removeEventListener(`popstate`, removeIframe);
  };

  window.addEventListener(`popstate`, removeIframe);
};
